<template>
  <div
    id="container"
    ref="container"
    style="min-height: 400px; width: 100%"
  ></div>
</template>

<script>
import ECharts from "echarts";

const cores = [
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
  "#c23531",
  "#2f4554",
  "#61a0a8",
  "#d48265",
  "#91c7ae",
  "#749f83",
  "#ca8622",
  "#bda29a",
  "#6e7074",
  "#546570",
  "#c4ccd3",
];

export default {
  name: "PieChartVendas",
  props: {
    dados: {
      type: Array,
    },
  },
  data: () => ({
    myChart: {},
    options: {
      color: cores,
      // tooltip: {},
      grid: {
        left: "5%",
        right: "5%",
        bottom: "0%",
        top: "15%",
        containLabel: true,
        tooltip: {
          formatter: (params) =>
            params.value
              ? parseFloat(params.value.toFixed(2)).toLocaleString("pt-BR", {
                  style: "decimal",
                  minimumFractionDigits: 2,
                })
              : 0,
        },
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        left: 5,
        top: 0,
        bottom: 20,
        data: [],
      },
      series: [
        {
          type: "pie",
          animation: true,
          radius: "75%",
          top: "29%",
          label: {
            normal: {
              show: true,
              // rotate: 90,
              formatter: (params) =>
                params.value
                  ? parseFloat(params.value.toFixed(2)).toLocaleString(
                      "pt-BR",
                      { style: "decimal", minimumFractionDigits: 2 }
                    )
                  : 0,
              fontSize: 12,
              position: "top",
              bottom: "20%",
              distance: 1,
              right: "6%",
            },
          },
          data: [],
        },
      ],
    },
  }),
  mounted() {
    this.init();
    window.addEventListener("resize", this.redimensionar);
  },
  destroy() {
    window.removeEventListener("resize", this.redimensionar);
  },
  methods: {
    init() {
      let dom = this.$refs.container;
      this.myChart = ECharts.init(dom);
      if (this.dados.length > 0) {
        this.myChart.setOption(this.options, true);
      } else {
        return;
      }
    },
    redimensionar() {
      window.onresize = () => {
        this.myChart.resize();
      };
    },
  },
  computed: {
    isMobileDevice: function() {
      return (
        typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1
      );
    },
  },
  watch: {
    dados: function(val, oldVal) {
      if (val) {
        let valores = val.map((item, i) => {
          if (item) {
            return {
              value: item.Valor,
              name: item.Legenda,
              itemStyle: { color: cores[i] },
            };
          }
        });

        let legenda = val.map((item, i) => {
          if (item) {
            return item.Legenda;
          }
        });

        this.options.series[0].data = valores;
        this.options.legend.data = legenda;
        if (this.isMobileDevice) {
          this.options.series[0].label.normal.show = false;
        }
        this.myChart.setOption(this.options, true);
      }
    },
  },
};
</script>

<style></style>
